import { Selector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'

export const productSizesForOptionsSelector: Selector<ReduxState, SelectOption[] | void> = state =>
  state.productSizes.productSizesForOptions
